import { Suspense } from 'react';
import { useLocation } from "react-router-dom";

import { loadComponent } from "./loadComponent";

function Widgets({ themePath }) {
  const location = useLocation();
  const pathname = location.pathname;

  const Widget = loadComponent(`selector/${themePath}${pathname}`);

  return (
    <Suspense
      fallback={<></>}
    >
      <Widget />
    </Suspense>
  );
}

export default Widgets;
